module.exports = __webpack_public_path__ + "img/c111aca.png";